import locales from './locales.json'

export const DEFAULT_LANGUAGE = locales.default
export const LANGUAGES = locales.languages
export const FLAT_LINE_WIDTH = 4
export const FLAT_LINE_COLOR = '#08457E'
export const ITINERARY_LINE_COLOR = '#ADD8E6'
